import { pushDataLayerUidForGtmClickTrigger } from '@/util/log'

/**
 * 祖先に向かって、class が ga- で始まるものを持つ要素があるか
 * @param {EventTarget} target
 * @returns {boolean}
 */
function clickTargetOrAncestorHasGaClass (target) {
  let el = target && target.nodeType === Node.ELEMENT_NODE ? target : target && target.parentElement
  while (el && el !== document.documentElement) {
    if (el.classList && el.classList.length > 0) {
      for (let i = 0; i < el.classList.length; i++) {
        if (el.classList[i].startsWith('ga-')) {
          return true
        }
      }
    }
    el = el.parentElement
  }
  return false
}

/**
 * GTM のクリックトリガーより先に dataLayer に uid を載せる（キャプチャで登録すること）
 * イベント名は push しない（クリックタグとの二重計測を避ける）
 */
export function installGtmGaClassClickUidDelegate () {
  document.addEventListener('click', (e) => {
    if (!clickTargetOrAncestorHasGaClass(e.target)) {
      return
    }
    pushDataLayerUidForGtmClickTrigger()
  }, true)
}
